import React from "react";
import CourseData from "./CourseData";
import { Link } from "react-router-dom";


const LandingByDate = () => {
  return (
    <div className="container" style={{ maxWidth: "100%" }}>
    

      <table class="table table-hover mt-4">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Start Date</th>
            <th scope="col">End Date</th>
            <th scope="col">Course</th>
            <th scope="col">Time Taken (hrs)</th>
          </tr>
        </thead>
        <tbody>
          {CourseData.map((course, index) => (
            <tr key={course.id}>
              <th scope="row">{index + 1}</th>
              <td> {course.startDate}</td>
              <td> {course.endDate}</td>
              <td>
                {" "}
                <Link
                  className="table-link"
                  key={course.course}
                  to={`/${course.course}`}
                >
                  {course.course} - {course.courseName}
                </Link>
              </td>
              <td> {course.timeTaken}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LandingByDate;
